// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mnt0B","rootNoMargin":"styles_rootNoMargin__ZyIom"};